const { removeSpecialChar } = require("@starberry/gatsby-library-common/BasicUtils")

function stringContainsNumber(_string) {
    return /\d/.test(_string);
}

//format URL using the search filters form values
export const createResultsUrl = (props) => {
    //lets form the URL

    let searchtypePath = ""
    let areaPath = ""
    let bedPath = ""
    let pricePath = ""
    let buildingPath = ""
    let sortPath = ""
    let layoutPath = ""

    if (props?.search_type === "buy") {
        searchtypePath = "for-sale/"
    } else if (props?.search_type === "rent") {
        searchtypePath = "to-rent/"
    } else {
        searchtypePath = "new-homes/for-sale/"
    }
    if (props?.area) {
        // first trim the value for start and end empty spaces; remove one more '-'
        // let areafilt = (props?.area).trim();
        // areafilt = areafilt.replace(/-+/gi,'-')
        // //remove special char except , and space
        // areafilt = areafilt.replace(/[^-,a-zA-Z ]/g, '');
        // // split using comma
        // areafilt = areafilt.split(",");
        // let areafiltUpd = areafilt.map(area => {
        //     if (area.charAt(0) == '-') {
        //         area = area.substring(1);
        //     }
        //     if (area.charAt((area.length)-1) == '-') {
        //         area = area.substring(0,area.length-1);
        //     }
        //     return area;
        // })
        // // again trim the values & join using -and- & replace multiple space
        // areaPath = "in-" + encodeURIComponent(decodeURIComponent(areafiltUpd.join("-and-"))) + "/"
        areaPath = "in-" + encodeURIComponent(decodeURIComponent(removeSpecialChar(props?.area))) + "/"
    } else {
        areaPath = `in-${(process.env.GATSBY_DEFAULT_AREA).toLowerCase()}/`;
    }
    if (props?.bedrooms) {
        if (parseInt(props?.bedrooms) === 0) {
            bedPath = "studio/"
        }

        if (parseInt(props?.bedrooms) > 0) {
            bedPath = props?.bedrooms + "-and-more-bedrooms/"
        }
    }
    if ( props?.min_price || props?.max_price ) {
        if (props?.min_price&& props?.max_price) {
            pricePath = "between-" + props?.min_price + "-and-" + props?.max_price + '/';
        } else if (props?.max_price) {
            pricePath = "below-" + props?.max_price + '/';
        } else if (props?.min_price) {
            pricePath = "above-" + props?.min_price + '/';
        }
    }
    if (props?.building_type) {
        buildingPath = "type-" + props?.building_type.replace(/ /g, '-') + "/"
    }
    if (props?.sortby) {
        if (props?.sortby === process.env.GATSBY_ALGOLIA_INDEX_NAME + "_price_asc") {
            sortPath = "sortby-price-asc/";
        }
        if (props?.sortby === process.env.GATSBY_ALGOLIA_INDEX_NAME + "_price_desc") {
            sortPath = "sortby-price-desc/";
        }
    }
    if (props?.layout) {
        layoutPath = "map-view/";
    }
    let myUrl = `/property/${searchtypePath}${areaPath}${bedPath}${pricePath}${buildingPath}${sortPath}${layoutPath}`;

    myUrl = myUrl.toLowerCase().replace(/ /g, '-');

    return myUrl;//navigate(myUrl)
}


export const parseResultsUrl = (location, base_path, search_type, department_type, property_status, index_name_val) => {
    //split the URL
    if (location) {
        var pathUri_main = ""
        let departmentVal = "residential"
        let searchtypeVal = ""
        let areaVal = process.env.GATSBY_DEFAULT_AREA ? process.env.GATSBY_DEFAULT_AREA : ""
        let bedVal = ""
        let minpriceVal = ""
        let maxpriceVal = ""
        let pageVal = "1"
        let buildingval = ""
        let sortVal = ""
        let layoutVal = ""
        let index_name = index_name_val || process.env.GATSBY_ALGOLIA_INDEX_NAME
        let propertyTypeVal = "residential"
        let mustincludeVal = ""
        let furnishVal = ""
        let branchVal = ""
        let radiusVal = ""

        let salespage  = location.pathname.indexOf("/property/for-sale") > -1
        let lettingspage = location.pathname.indexOf("/property/to-rent") > -1
        let newdevelopmentspage = location.pathname.indexOf("/property/new-homes/for-sale") > -1
        let new_developments = location.pathname.indexOf("/new-developments/for-sale") > -1
        let commercial_sale_page = location.pathname.indexOf("/commercial-property/for-sale") > -1
        let commercial_rent_page = location.pathname.indexOf("/commercial-property/to-rent") > -1
        let property_collection = location.pathname.indexOf("/property-collection/for-sale") > -1
        let property_students = location.pathname.indexOf("/property-students/to-rent") > -1

        if(base_path){
            pathUri_main = location.pathname.split(base_path)
            searchtypeVal = search_type
            departmentVal = department_type

        } else{

            if (salespage === true) {
                pathUri_main = location.pathname.split("/property/for-sale")
                searchtypeVal = "sales"
            }
            else if (lettingspage === true) {
                pathUri_main = location.pathname.split("/property/to-rent")
                searchtypeVal = "lettings"
            }
            else if (newdevelopmentspage === true) {
                pathUri_main = location.pathname.split("/property/new-homes/for-sale")
                searchtypeVal = "sales"
                index_name = process.env.GATSBY_ALGOLIA_NEW_DEVELOPMENTS_INDEX_NAME || process.env.GATSBY_ALGOLIA_INDEX_NAME_NEW_DEVELOPMENT
                propertyTypeVal = "new_developments"
            } 
            else if (new_developments === true) {
                pathUri_main = location.pathname.split("/new-developments/for-sale")
                searchtypeVal = "sales"
                index_name = process.env.GATSBY_ALGOLIA_NEW_DEVELOPMENTS_INDEX_NAME || process.env.GATSBY_ALGOLIA_INDEX_NAME_NEW_DEVELOPMENT
                propertyTypeVal = "newdevelopments"
            }
            else if (commercial_sale_page === true) {
                pathUri_main = location.pathname.split("/commercial-property/for-sale")
                searchtypeVal = "sales"
                departmentVal = "commercial"
            } 
            else if (commercial_rent_page === true) {
                pathUri_main = location.pathname.split("/commercial-property/to-rent")
                searchtypeVal = "lettings"
                departmentVal = "commercial"
            }
            else if (property_collection === true) {
                pathUri_main = location.pathname.split("/property-collection/for-sale")
                searchtypeVal = "sales"
            }
            else if (property_students === true) {
                pathUri_main = location.pathname.split("/property-students/to-rent")
                searchtypeVal = "lettings"
            }
        }

        if (pathUri_main[1]) {
            // following could be regexp
            let pathUri = pathUri_main[1].split("/")

            //console.log("pathUri_main", pathUri[0])
            

            //lets loop
            for (let vi = 0; vi <= pathUri.length; vi++) {
                // check for area
                if (typeof pathUri[vi] === "undefined") {
                    continue
                }

                // Area
                if (pathUri[vi].indexOf("in-") >= 0) {
                    areaVal = removeSpecialChar(pathUri[vi].replace("in-", ""), " ")
                }

                // Bedrooms
                if (pathUri[vi].indexOf("-and-more-") >= 0) {
                    bedVal = pathUri[vi].replace("-and-more-bedrooms", "")
                }

                // Property type
                // if (pathUri[vi].indexOf("type-") >= 0) {
                //     buildingval = pathUri[vi].replace("type-", "")
                // }

                // Price
                if (
                pathUri[vi].indexOf("between-") >= 0 ||
                pathUri[vi].indexOf("above-") >= 0 ||
                pathUri[vi].indexOf("below-") >= 0 || 
                pathUri[vi].indexOf("under-") >= 0 || 
                pathUri[vi].indexOf("over-") >= 0
                ) {
                    let priceFilt1 = pathUri[vi].split("above-")
                    if (priceFilt1[1]) {
                        minpriceVal = priceFilt1[1]
                    }
                    let priceFilt2 = pathUri[vi].split("below-")
                    if (priceFilt2[1]) {
                        maxpriceVal = priceFilt2[1]
                    }
                    let priceFilt3 = pathUri[vi].split("between-")
                    if (priceFilt3[1]) {
                        let priceFilt4 = priceFilt3[1].split("-and-")
                        minpriceVal = priceFilt4[0]
                        maxpriceVal = priceFilt4[1]
                    }
                    let priceFilt4 = pathUri[vi].split("over-")
                    if (priceFilt4[1]) {
                        minpriceVal = priceFilt4[1]
                    }
                    let priceFilt5 = pathUri[vi].split("under-")
                    if (priceFilt5[1]) {
                        maxpriceVal = priceFilt5[1]
                    }
                }

                // Sort by
                if (pathUri[vi].indexOf("sortby-") >= 0) {
                    let sortVal_filt = pathUri[vi].replace("sortby-", "")

                    if (sortVal_filt === "") {
                        sortVal = index_name;
                    }

                    if (sortVal_filt === "price-asc") {
                        sortVal = index_name + "_price_asc"
                    }

                    if (sortVal_filt === "price-desc") {
                        sortVal = index_name + "_price_desc"
                    }

                    if (sortVal_filt === "newest") {
                        sortVal = index_name + "_newest"
                    }

                    if (sortVal_filt === "oldest") {
                        sortVal = index_name + "_oldest"
                    }
                }

                // Page
                if (pathUri[vi].indexOf("page") >= 0) {
                    pageVal = pathUri[vi].replace("page-", "")
                }

                if (pathUri[vi].indexOf("map-view") >= 0) {
                    layoutVal = "map"
                }

                // Mustinclude
                if (pathUri[vi].indexOf("with-") >= 0) {
                    //mustincludeVal = pathUri[vi].replace("with-", "")
                    var mustincludeArrfilt = pathUri[vi].replace("with-", "")
                    mustincludeVal = mustincludeArrfilt.split("-and-")
                }

                // Furnishing Val
                if (pathUri[vi].indexOf("furnishing-") >= 0) {
                    furnishVal = pathUri[vi].replace("furnishing-", "")
                }

                // Branch Val
                if (pathUri[vi].indexOf("branch-") >= 0) {
                    branchVal = pathUri[vi].replace("branch-", "")
                }


                // Radius Val
                if (pathUri[vi].indexOf("radius-") >= 0) {
                    radiusVal = pathUri[vi].replace("radius-", "").replace("-miles", "")
                }

                // Property type
                if (pathUri && pathUri[1] && !stringContainsNumber(pathUri[1]) && pathUri[1]!= "" && pathUri[1]!= "sortby-price-desc" && pathUri[1]!= "sortby-price-asc" && pathUri[1]!= "sortby-most-recent") {
                    buildingval = pathUri[1]
                }

            }
        }
        

        //console.log("buildingval", buildingval);

        var mydatarr = []
        mydatarr['indexVal'] = index_name
        mydatarr['departmentVal'] = departmentVal
        mydatarr['searchtypeVal'] = searchtypeVal
        mydatarr['areaVal'] = areaVal
        mydatarr['bedVal'] = bedVal
        mydatarr['minpriceVal'] = minpriceVal
        mydatarr['maxpriceVal'] = maxpriceVal
        mydatarr['pageVal'] = pageVal
        mydatarr['buildingval'] = buildingval
        mydatarr['sortVal'] = sortVal
        mydatarr['layoutVal'] = layoutVal
        mydatarr['propertyTypeVal'] = propertyTypeVal
        mydatarr['mustincludeVal'] = mustincludeVal
        mydatarr['furnishVal'] = furnishVal
        mydatarr['branchVal'] = branchVal
        mydatarr['radiusVal'] = radiusVal
        return mydatarr
    }
    return false
}

export const generateFiltersfromPageData = (departmentVal,searchtypeVal,areaVal,bedVal,minpriceVal,maxpriceVal,buildingval, mustincludeVal, furnishVal, branchVal) => {
    // lets from the filters 
    // here the search login lives
    var myfilter = []
    //facet filters
    if(departmentVal){
        myfilter.push("(department:"+departmentVal+")")
    }
    if(searchtypeVal){
        myfilter.push("(search_type:"+searchtypeVal+") OR (searchType:"+searchtypeVal+")")
    }
    // if(areaVal && areaVal !== "london"){
    //     myfilter.push("(area:"+areaVal+" OR post_code:"+areaVal+" OR display_address:"+areaVal+")")
    // }
    if(buildingval){
        myfilter.push("(building:"+buildingval+")")
    }
    //numberic filters
    if(bedVal && bedVal > 0){
        myfilter.push("(bedroom >= "+bedVal+")")
    }
    if( (minpriceVal && minpriceVal > 0) && (maxpriceVal && maxpriceVal > 0) ){
        myfilter.push("(price >= "+minpriceVal+" AND price <= "+maxpriceVal+")")
    } else if(maxpriceVal && maxpriceVal > 0) {
        myfilter.push("(price <= "+maxpriceVal+")")
    } else if(minpriceVal && minpriceVal > 0) {
        myfilter.push("(price >= "+minpriceVal+")")
    }
    // if(pageVal){
    //     myfilter.push("(page: "+(pageVal)+")")
    // }
    myfilter.push("(publish: true)")

    // Mustinclude
    if (mustincludeVal?.length > 0) {
        //query += `&refinementList[mustInclude]=` + mustincludeVal
        for (let v = 0; v <= mustincludeVal.length; v++) {
            if (typeof mustincludeVal[v] !== "undefined") {
                myfilter.push("(mustInclude:"+mustincludeVal[v]+")")
            }
        }
    }

    if(furnishVal){
        myfilter.push("(furnishing:"+furnishVal+")")
    }
    
    if(branchVal){
        myfilter.push("(office_crm_id:"+branchVal+")")
    }

    return myfilter.join(' AND ')
}
